export const shadows = {
  card: "4px 4px 20px #CCCFD8",
  rangeDot: "0px 3px 10px rgba(48, 143, 255, 0.4)",
}
